module.exports = __webpack_public_path__ + "static/img/10.9c4668d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/zh/10.png
// module id = qoKo
// module chunks = 0